/*
 * Project: bellcloud
 * File: packages/utils/device/devicePacketCodec.ts
 * Author: SWAN
 * Created: 2025-01-27
 * Description: 바이너리 패킷 프레임 ↔ JSON (SOF/DST/길이/CRC/페이로드). LITE·MINI 공통.
 */

import type { FunctionParameter } from '../../protocols/fns';
import type { DeviceInfo } from '../../types/device/lite/deviceInfo';
import { DeviceType, type ProtocolType } from '../../types/device/common/deviceTypes';
import {
  SOF,
  EOF,
  DEFAULT_SEQ,
  DEFAULT_SRC,
  MINI_DST,
  LITE_DST,
} from '../../protocols/constants';
import { PacketConverter } from './converters/payloadCodec';
import { calculateCRC16 } from './crc16';

export { calculateCRC16 };
// Common payload conversion utilities
function jsonToPayload(
  jsonData: Record<string, unknown>,
  paramDefs: FunctionParameter[],
  protocol?: ProtocolType,
  deviceInfo?: { sensor_type?: Array<{ value: number; label: string }> }
): number[] {
  return PacketConverter.jsonToPayload(jsonData, paramDefs, protocol, deviceInfo);
}

// Common packet utilities
export function jsonToPacket(
  classId: number,
  functionId: number,
  data: Record<string, unknown>,
  paramDefs: FunctionParameter[],
  protocol?: ProtocolType,
  deviceInfo?: { sensor_type?: Array<{ value: number; label: string }> }
): number[] {
  // protocol에 따라 올바른 DST 선택
  const dst = protocol === DeviceType.MINI ? MINI_DST : LITE_DST;
  const header = [SOF, dst, DEFAULT_SRC, DEFAULT_SEQ, classId, functionId];
  const payload = jsonToPayload(data, paramDefs, protocol, deviceInfo);
  const len = payload.length;

  header.push(len & 0xff, (len >> 8) & 0xff);
  const packet = [...header, ...payload];
  const crcTarget = packet.slice(1);
  const crc = calculateCRC16(crcTarget);

  packet.push(crc & 0xff, (crc >> 8) & 0xff);
  packet.push(EOF);
  packet.push(10); // LF (Line Feed) 추가
  return packet;
}

export function packetToJson(
  payload: number[],
  paramDefs: FunctionParameter[],
  protocol?: ProtocolType,
  deviceInfo?: DeviceInfo
): Record<string, unknown> {
  return PacketConverter.packetToJson(payload, paramDefs, protocol, deviceInfo);
}
